module.exports = __webpack_public_path__ + "assets/img/menu-contacts.6a1ed0c5.svg";